import { render } from "./VehicleSettings.vue?vue&type=template&id=b3f6d39c"
import script from "./VehicleSettings.vue?vue&type=script&lang=js"
export * from "./VehicleSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__